module.exports = __webpack_public_path__ + "static/img/small_banner_02.5747320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/small_banner_02.png
// module id = s2Ug
// module chunks = 9